import React from 'react';
import PropTypes from 'prop-types';
import { max } from 'lodash';
import Card from '../../../core/layout/Card';
import BarChart from '../../../core/chart/BarChart';
import colors from '../../../core/chart/colors';

const ActiveStudentsByMonthChart = (props) => (
  <Card title="Active Students By Month" loading={props.loading}>
    <BarChart
      height={350}
      labels={props.data.map((d) => d.id)}
      data={props.data}
      colors={colors}
      dataFormat={[
        {
          label: 'Total',
          yAxisID: 'total',
          valueRender: (item) => item.totalCount || 0,
        },
        {
          label: 'Same Day',
          yAxisID: 'day',
          valueRender: (item) => item.untilDayCount || 0,
          fill: false,
          type: 'line',
        },
      ]}
      options={{
        scales: {
          yAxes: [
            {
              id: 'day',
              type: 'linear',
              display: 'true',
              position: 'right',
              ticks: {
                beginAtZero: true,
                max: max(props.data.map((d) => d.totalCount)) + 500,
              },
              gridLines: {
                drawOnChartArea: false,
                max: max(props.data.map((d) => d.totalCount)) + 500,
              },
              scaleLabel: {
                display: 'true',
                labelString: 'Amount at the same day',
              },
            },
            {
              type: 'linear',
              display: 'true',
              position: 'left',
              id: 'total',
              ticks: {
                beginAtZero: true,
                max: max(props.data.map((d) => d.totalCount)) + 500,
              },
              gridLines: {
                max: max(props.data.map((d) => d.totalCount)) + 500,
              },
              scaleLabel: {
                display: 'true',
                labelString: 'Total count',
              },
            },
          ],
        },
        hover: {
          mode: 'nearest',
          intersect: true,
        },
        tooltips: {
          mode: 'index',
          intersect: false,
        },
        legend: {
          display: true,
          onClick: () => true,
        },
      }}
    />
  </Card>
);

ActiveStudentsByMonthChart.propTypes = {
  loading: PropTypes.bool.isRequired,
  data: PropTypes.array,
};

ActiveStudentsByMonthChart.defaultProps = {
  data: [],
};

export default ActiveStudentsByMonthChart;
